import _ from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { joinApiSerializedValidationErrorMessages } from "../../dto/common/api-validation-error.messages.utils";
import { IApiError } from "../../models";
import { isTranslationKey } from "../localize.helpers";
import { Log } from "../log.helpers";
import { ToastBoxStyled } from "./toast-widgets.styled";

interface IToastErrorBox {
  message: string;
  error?: IApiError | string;
}

export const ToastErrorBox: FC<IToastErrorBox> = ({ message, error }) => {
  const { t } = useTranslation();
  Log.debug("Toast error box:", message, error);

  if (!error) {
    return isTranslationKey(message) ? t(message) : message;
  }

  let errorDetails = "";

  if (typeof error === "string") {
    errorDetails = error;
  } else if (error.validationErrors?.length) {
    errorDetails = joinApiSerializedValidationErrorMessages(
      error.validationErrors,
    );
  } else if (error.translationKey) {
    errorDetails = error.translationKey;
  } else if (error.errors && typeof error.errors === "string") {
    errorDetails = error.errors;
  } else if (_.isArray(error.errors) && error.errors?.length) {
    const errFirst = error.errors[0];

    if (typeof errFirst === "string") {
      errorDetails = errFirst;
    } else if (errFirst.message) {
      errorDetails = errFirst.message;
    }
  } else if (error.message) {
    errorDetails = error.message;
  }

  const displayMessage = isTranslationKey(message) ? t(message) : message;

  // Avoid rendering the same text twice when `errorDetails` equals the main `displayMessage`.
  if (errorDetails && errorDetails === displayMessage) {
    return (
      <ToastBoxStyled>
        <p className="message">{displayMessage}</p>
      </ToastBoxStyled>
    );
  }

  return (
    <ToastBoxStyled>
      <p className="message">{displayMessage}</p>
      {!!errorDetails && (
        <p className="details">
          {isTranslationKey(errorDetails)
            ? t(errorDetails, (error as IApiError)?.translationParams ?? {})
            : errorDetails}
        </p>
      )}
    </ToastBoxStyled>
  );
};
